export const theme = {
    primaryDark: "#362621",
    primaryLight: "#ebd5a8",
    primaryHover: "#4F6071",
    secondaryDark: "#7F7E7E",
    secondaryLight: "#CDC3A4",
};